import React from 'react';
import styled from 'styled-components/macro';
import { responsive } from '../../resources/constantes.json';
import { useTranslate } from '../../contexts/languageContext';
import BarraProgresoStyled from '../../components/BarraProgresoStyled';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import Logo from '../../containers/Logo';
import {
  useIsMobile,
  useIsDesktopBig,
  useIsDesktop,
} from '../../hooks/useMediaQuery';
import { fmt } from '../../utils';
import FiltroCandidatos from './FiltroCandidatos';
import { FiChevronDown } from 'react-icons/fi';
import { AnimatePresence, motion } from 'framer-motion';
import useIni from '../../hooks/useIni';
import Cargo from 'svg/Cargo';
import VerticalExpand from '../../components/VerticalExpand';
import { themes } from '../../styles/themes';
import ArrowInicio from '../../components/svg/ArrowInicio';
import { UserIcon } from '../../assets/img';
import constantes from '../../resources/constantes.json';
import useLoseFocusOnHover from '../../hooks/useLoseFocusOnHover';
import useTableHeightAdjustment from '../../hooks/useTableHeightAdjustment';

const isReducidoFramed = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return window.top !== window && searchParams.get('reducido') === 'true';
};

const formatCandidatoName = candidato => {
  let candidatonombre = '';
  if (candidato.codcan !== '0') {
    candidatonombre += `(${candidato.codcan}) `;
  }
  candidatonombre += `${candidato.nomcan} ${candidato.apecan}`;
  return candidatonombre;
};

const FilaTablaPartidos = props => {
  const t = useTranslate();
  const nomenclator = useNomenclator();
  const partido = props.partido.act;
  const estiloComposicion = props.soloConCargo;
  const isMobile = useIsMobile();
  const isDesktopBig = useIsDesktopBig();
  const isDesktop = useIsDesktop();
  const partidoInfo = nomenclator.partidos[Number(partido.codpar) - 1];
  const [isOpen, setIsOpen] = React.useState(false);
  const [candidatos, setCandidatos] = React.useState(partido.cantotabla);
  const openButtonRef = useLoseFocusOnHover();
  const [candidateTableHeight, getElements] = useTableHeightAdjustment();

  React.useEffect(() => {
    setIsOpen(false);
    setCandidatos(partido.cantotabla);
  }, [partido]);

  const expandirContraer = e => {
    if (typeof e === 'object') e.preventDefault();
    setIsOpen(!isOpen);
  };

  const showCurulCandidato = candidato => {
    if (props.mostrarCargos) {
      if (candidato.pref === '1' && candidato.carg === '1') {
        return true;
      } else if (candidato.codcan !== '0' && candidato.carg === '1') {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const showVotosCandidato = candidato => {
    if (candidato.pref === '1') {
      return true;
    } else if (candidato.pref === '0' && candidato.codcan === '0') {
      return true;
    } else {
      return false;
    }
  };
  const ElementoListaCandidatos = React.forwardRef(
    ({ candidato, index }, ref) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { showCurules } = useIni();
      return (
        <ElementoCandidatos ref={ref} index={index} isDesktopBig={isDesktopBig}>
          <NombreCandidatoContainer>
            {showCurules ? (
              <span
                css={`
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 40px;
                `}
              >
                {candidato.carg === '1' ? (
                  <Cargo style={{ marginRight: '.5rem' }} />
                ) : null}
              </span>
            ) : (
              <div style={{ width: '40px' }} />
            )}
            <NombreCandidato>{formatCandidatoName(candidato)}</NombreCandidato>
          </NombreCandidatoContainer>
          <div
            style={{
              display: 'flex',
              paddingLeft: isDesktopBig || !isDesktop ? '' : '40px',
              paddingTop: isDesktopBig || !isDesktop ? '' : '12px',
              alignItems: isDesktop ? '' : 'end',
              width: isMobile ? '50%' : '',
              marginRight: '10px',
              columnGap: '10px',
            }}
          >
            {showVotosCandidato(candidato) && (
              <>
                <p className="percent">{candidato.pvot}</p>{' '}
                <p
                  style={{
                    fontSize: isMobile ? '1.4rem' : '1.8rem',
                    width: isMobile ? '50%' : '',
                    minWidth: isMobile ? '' : '50px',
                    textAlign: isMobile ? 'end' : '',
                  }}
                >
                  {fmt(candidato.vot)}
                </p>
              </>
            )}
            <ContenedorVotoProferente>
              {candidato.empate === '1' && candidato.carg !== '0' ? (
                <SinAsignar title={t('curulSA')}>{t('SA')}</SinAsignar>
              ) : (
                showCurulCandidato(candidato) && <VotoPreferente />
              )}
            </ContenedorVotoProferente>
          </div>
        </ElementoCandidatos>
      );
    }
  );
  const showCandidatePicture = props.isUnicandidato && partido.cantotabla;
  const finalPartUrl = showCandidatePicture
    ? partido.cantotabla[0]?.cedula ?? 'fakeUrl'
    : '';
  const basenameUrl = `${constantes.rutas.candidatos}${finalPartUrl}`;

  const showDesplegableButton =
    props.mostrarCandidatos && !props.isUnicandidato;
  const desplegableButton = (
    <ContainerChevron
      style={{
        marginLeft: isDesktopBig ? '' : 'auto',
        marginRight: isDesktopBig ? '' : 'auto',
      }}
    >
      <Chevron animate={{ rotateZ: isOpen ? '180deg' : '0deg' }}>
        <div
          style={{
            width: '5rem',
            aspectRatio: '1/1',
            backgroundColor: themes.tarjetasInicio.linkBtn,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '100%',
            color: '#FFF',
          }}
        >
          <ArrowInicio />
        </div>
      </Chevron>
    </ContainerChevron>
  );
  return (
    <BigContainer
      ref={openButtonRef}
      tabIndex={props.isUnicandidato ? '-1' : undefined}
      onClick={expandirContraer}
    >
      {partidoInfo && (
        <Container
          estiloComposicion={estiloComposicion}
          className={`className`}
          showCargos={false}
          style={{ margin: 0, width: '100%' }}
        >
          <BloquePartido
            className="bloque flex"
            style={!props.isUnicandidato ? { cursor: 'pointer' } : {}}
          >
            <div
              style={{
                display: 'flex',
                alignItems: isDesktopBig ? 'center' : '',
                flexDirection: isDesktopBig ? 'row' : 'column',
                rowGap: isDesktopBig ? '' : isDesktop ? '20px' : '12px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  alignSelf: isDesktopBig ? '' : 'flex-start',
                  width: isDesktopBig ? '' : '100%',
                }}
              >
                {showCandidatePicture && (
                  <StyledPhoto>
                    <StyledLogo
                      isMobile={isMobile}
                      showCandidatePicture={showCandidatePicture}
                      basenameUrl={basenameUrl}
                      shouldDisplayEmptySpace={true}
                      isJpg={true}
                      redondo={true}
                    >
                      <img
                        style={{
                          height: '75%',
                          aspectRatio: '1/1',
                        }}
                        src={UserIcon}
                        alt={'candidato'}
                      />
                    </StyledLogo>
                  </StyledPhoto>
                )}
                <div style={{ marginRight: '40px' }}>
                  <StyledLogo
                    codpar={
                      nomenclator.partidos[Number(partido.codpar) - 1].codpar
                    }
                    width={isMobile ? '80px' : '100px'}
                    showCandidatePicture={showCandidatePicture}
                    isMobile={isMobile}
                    shouldDisplayEmptySpace={true}
                    defaultBackgroundColor={partidoInfo?.color}
                  />
                </div>
                {showDesplegableButton && !isDesktopBig && (
                  <div style={{ marginLeft: 'auto' }}>{desplegableButton}</div>
                )}
              </div>
              <div
                className={estiloComposicion ? 'configComposicion' : ''}
                style={{
                  alignSelf:
                    showDesplegableButton && !isDesktopBig ? 'flex-start' : '',
                }}
              >
                {showCandidatePicture && (
                  <NombreCandidatoConsulta>
                    {partido.cantotabla[0].nomcan}{' '}
                    {partido.cantotabla[0].apecan}
                  </NombreCandidatoConsulta>
                )}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    columnGap: '8px',
                  }}
                >
                  <div
                    style={{
                      width: isMobile ? '12px' : '16px',
                      aspectRatio: '1/1',
                      borderRadius: '100%',
                      backgroundColor: partidoInfo.color
                        ? partidoInfo.color
                        : '#c4c4c4',
                    }}
                  />
                  <NombrePartido isUnicandidato={props.isUnicandidato}>
                    {partidoInfo.nombre.toLowerCase()}
                  </NombrePartido>
                </div>
              </div>
              {showDesplegableButton && isDesktopBig && desplegableButton}
            </div>

            <Contenido>
              <SecondRow className="secondRow">
                {props.mostrarVotos && (
                  <BarraProgresoStyled
                    height={props.primeroBogota ? '30px' : '12px'}
                    porcentaje={partido.pvot}
                    umbral={props.primeroBogota?.umbral}
                    color={partidoInfo.color ? partidoInfo.color : '#c4c4c4'}
                    cual={partido.cod}
                    maxWidth={isMobile ? '100%' : undefined}
                  />
                )}
              </SecondRow>
              <LastRow className={'lastRow'}>
                {props.mostrarVotos && (
                  <Datos className="agr flex">
                    <div className="porcAgr">{partido.pvot}</div>
                    <div className="numAgr">{fmt(partido.vot)}</div>
                  </Datos>
                )}
                {/* {props.mostrarCargos && (
                  <InfoCurules
                    cargos={Number(partido.cargElectos)}
                    cargEmpatados={partido.cargEmpatados}
                    color={partidoInfo.color}
                  />
                )} */}
              </LastRow>
            </Contenido>
          </BloquePartido>
          {!props.isUnicandidato && partido.cantotabla && (
            <>
              <div style={{ height: isOpen ? '40px' : '' }} />
              <VerticalExpand open={isOpen}>
                <div>
                  {/* <Divider />
                <FiltroCandidatos
                  candidatos={partido.cantotabla}
                  setCandidatos={setCandidatos}
                /> */}
                  <ContainerLista style={{ maxHeight: candidateTableHeight }}>
                    {candidatos.length > 0 ? (
                      getElements(
                        candidatos.map((candidato, i) => {
                          return (
                            <ElementoListaCandidatos
                              candidato={candidato}
                              key={i}
                              index={i}
                            />
                          );
                        })
                      )
                    ) : (
                      <ElementoCandidatos>
                        {t('sinResultados')}
                      </ElementoCandidatos>
                    )}
                  </ContainerLista>
                </div>
              </VerticalExpand>
            </>
          )}
        </Container>
      )}
    </BigContainer>
  );
};

const ContenedorVotoProferente = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  @media (max-width: ${responsive.mobile}px) {
    margin-left: 10px;
  }
`;

const VotoPreferente = styled.span`
  background: #54b8ec;
  height: 5px;
  width: 5px;
  display: block;
  border-radius: 50%;
`;

const SinAsignar = styled.span`
  display: flex;
  justify-content: flex-start;
`;

const ContainerLista = styled.div`
  max-height: 340px;
  overflow: auto;
`;
const StyledPhoto = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  background: #fff;
  overflow: hidden;
  aspect-ratio: 1/1;
  border-width: 2px;
  border-color: #d8dfea;
  border-style: solid;
  border-radius: 100%;
  margin-right: 16px;
  @media (max-width: ${responsive.mobile}px) {
    height: 60px;
  }
`;
const NombreCandidato = styled.p`
  width: 300px;
  font-size: 1.6rem;
  margin-right: 0;
  @media (max-width: 1400px) {
    width: 200px;
  }
  @media (max-width: ${responsive.desktop - 1}px) {
    width: auto;
    margin-right: 10px;
  }
  @media (max-width: ${responsive.mobile}px) {
    font-size: 1.4rem;
    width: 100%;
  }
`;

const NombreCandidatoContainer = styled.div`
  display: flex;
  margin-right: auto;
  @media (max-width: ${responsive.mobile}px) {
    width: 50%;
  }
`;

const ElementoCandidatos = styled.div`
  display: flex;
  flex-direction: ${({ isDesktopBig }) => (isDesktopBig ? 'row' : 'column')};
  background-color: ${({ index }) =>
    index % 2 === 0 ? 'rgba(216, 223, 250, 0.3)' : ''};
  padding: 12px 0;
  .percent {
    font-size: 1.8rem;
    font-weight: 700;
    width: 100px;
    @media (max-width: ${responsive.mobile}px) {
      font-size: 1.4rem;
      width: 50%;
      text-align: end;
    }
  }
  @media (max-width: ${responsive.tablet}px) {
    flex-direction: row;
    justify-content: space-between;
  }
  @media (max-width: ${responsive.mobile}px) {
    font-size: 1.4rem;
  }
`;

const BigContainer = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: ${themes.tarjetasCandidaturas.backgroundColor};
  border-radius: 25px;
  margin-bottom: 30px;
  padding: 20px 0px;
  margin-right: 20px;
  color: ${themes.tarjetasCandidaturas.textColor};
  cursor: ${({ tabIndex }) => (tabIndex === '-1' ? 'auto' : 'pointer')};
  @media (max-width: ${responsive.mobile}px) {
    margin-right: 10px;
  }
`;

const NombrePartido = styled(({ isUnicandidato, ...rest }) => <p {...rest} />)`
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 400;
  text-transform: capitalize;
  @media (max-width: ${responsive.mobile}px) {
    font-size: 1.2rem;
  }
`;

const NombreCandidatoConsulta = styled.p`
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 800;
  margin-bottom: 12px;
  @media (max-width: ${responsive.mobile}px) {
    font-size: 1.4rem;
    margin-bottom: 8px;
  }
`;

const BloquePartido = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 30px;
  @media (max-width: ${responsive.mobile}px) {
    padding: 0 20px;
  }
`;

const Container = styled(({ estiloComposicion, showCargos, ...rest }) => (
  <div {...rest} />
))`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin: 1rem;
  width: calc(100% - 1rem);

  margin-top: ${({ estiloComposicion }) =>
    estiloComposicion ? '0px' : '1rem'};
  margin-bottom: ${({ estiloComposicion }) =>
    estiloComposicion ? '0px' : '1rem'};

  .porcAgr {
    font-size: 2.2rem;
    font-style: normal;
    font-weight: 800;
    @media (max-width: ${responsive.mobile}px) {
      font-size: 1.4rem;
    }
  }

  @media screen and (max-width: ${responsive.tablet}px) {
    width: ${({ showCargos }) =>
      showCargos ? '70% !important' : isReducidoFramed() ? '100%' : '96%'};
  }

  @media screen and (max-width: ${responsive.mobile}px) {
    padding: 0;
  }
`;

const StyledLogo = styled(Logo)`
  flex: 0 0 auto;
  background: transparent;
  height: '100%';
`;

const ContainerChevron = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
`;

const Chevron = styled(motion.div)`
  display: flex;
  align-items: center;
  visibility: ${isReducidoFramed() ? 'hidden' : 'visible'};
  button {
    background: transparent;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`;

const Contenido = styled.div`
  display: flex;
  flex-direction: column;
  &.contenidoListas .up {
    align-items: center;
  }
  .titleUp {
    height: 100%;
  }
`;

const Datos = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  &.listas {
    flex-direction: row;
    align-items: baseline;
  }
  .numAgr {
    font-size: 1.6rem;
    font-weight: 400;
    @media (max-width: ${responsive.mobile}px) {
      font-size: 1.2rem;
    }
  }

  .porcListas {
    font-weight: 600;
    font-size: 1.6rem;
    margin-right: 1rem;

    @media print {
      font-size: 1rem;
    }
  }

  .numListas {
    font-size: 1.4rem;
    font-weight: 400;

    @media print {
      font-size: 1rem;
    }
  }
`;

const LastRow = styled.div`
  display: flex;
  font-weight: 500;
  .configComposicion {
    display: flex;
    align-items: center;
  }
`;

const SecondRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 12px;
  @media (max-width: ${responsive.mobile}px) {
    margin-top: 16px;
    margin-bottom: 8px;
  }
`;

const Divider = styled.div`
  border-bottom: 2px dashed #c2d2f1;
  padding-top: ${isReducidoFramed() ? '0' : '3rem'};
  padding-bottom: ${isReducidoFramed() ? '0' : '1rem'};

  @media print {
    display: none;
  }
`;

export default FilaTablaPartidos;
